<template>
  <div id="app">
    <van-nav-bar fixed placeholder :title="currTitle" :left-arrow="showBack" @click-left="backpage" />
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      currTitle: '',
      showBack: true,
      keepArr: []
    }
  },
  watch: {
    '$route': {
      handler() {
        this.currTitle = this.$route.meta.cname
        if (this.$route.meta.showLeft) {
          this.showBack = true
        } else {
          this.showBack = false
        }
      },
      immediate: true
    }
  },
  methods: {
    backpage() {
      history.go(-1)
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 450px; 
  margin: 0 auto;
}

html {
  font-size: 37.5px;
  box-sizing: border-box;
}
.slh2{
  display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
  -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
  -webkit-line-clamp: 2; /* 2行，只有 webkit内核支持 */
  word-break: break-all; /* 纯英文换行 */
  overflow: hidden;
}
.slh3{
  display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
  -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
  -webkit-line-clamp: 3; /* 2行，只有 webkit内核支持 */
  word-break: break-all; /* 纯英文换行 */
  overflow: hidden;
}
.slh{
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.fs13{
  font-size: 13px;
}
.fs14{
  font-size: 14px;
}
</style>
